{
  "feedbackTextInputLabel": "Partagez vos pensées",
  "feedbackTextInputPlaceholder": "Je voulais partager quelques retours...",
  "likeOrDislikeWithFeatureName": "Vous aimez {{featureName}} ?",
  "linkTo": "Partager vos commentaires",
  "other": "Autre chose",
  "subjectTextInputLabel": "Sujet",
  "subjectTextInputPlaceholder": "(Choisir un sujet)",
  "successMessage": "Vos commentaires ont été reçus.",
  "description": "Nous aimerions connaître votre avis sur la manière dont nous pouvons améliorer notre produit.",
  "title": "Partager vos commentaires"
}
